import classNames from 'classnames'
import { FC } from 'react'
import { MaintenanceProductStatusValue } from '@/domain/models/maintenanceProductStatus.ts'
import {
  CellNode,
  DataGridApi,
  DataGridColumnDefs,
  RowNode,
} from '@/presentation/common/components/dataGrid/lib/api.types.ts'
import { MTCellBadge } from '@/presentation/common/components/maintainer/table/cells/MTCellBadge.tsx'

type Props = {
  cellNode: CellNode<MaintenanceProductStatusValue>
  node: RowNode
  column: DataGridColumnDefs
  api: DataGridApi
}

export const MTCellMaintenanceProductStatus: FC<Props> = ({ cellNode, node, column, api }) => {
  const statusClassName = classNames('uppercase', {
    'bg-green-50' : cellNode.value === MaintenanceProductStatusValue.USED,
    'bg-blue-50'  : cellNode.value === MaintenanceProductStatusValue.NOT_USED,
  })

  return (
    <MTCellBadge {...{ cellNode, node, column, api }} className={statusClassName}/>
  )
}
